import {
  GET_PENDING_EUR_TRANSACTIONS_BEGIN,
  GET_PENDING_EUR_TRANSACTIONS_SUCCESS,
  GET_PENDING_EUR_TRANSACTIONS_FAIL,

  CREATE_PENDING_EUR_TRANSACTIONS_BEGIN,
  CREATE_PENDING_EUR_TRANSACTIONS_SUCCESS,
  CREATE_PENDING_EUR_TRANSACTIONS_FAIL,

  DELETE_PENDING_EUR_TRANSACTIONS_BEGIN,
  DELETE_PENDING_EUR_TRANSACTIONS_SUCCESS,
  DELETE_PENDING_EUR_TRANSACTIONS_FAIL,

  CREATE_TRUELAYER_PAYMENT_BEGIN,
  CREATE_TRUELAYER_PAYMENT_SUCCESS,
  CREATE_TRUELAYER_PAYMENT_FAIL,

  GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_BEGIN,
  GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_SUCCESS,
  GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_FAIL,
} from '../actions/types';

const initialState = {
  eurDeposits: [],
  pagination: [],
  errors: [],
  success: [],
  loading: false,
  trueLayer: {},
  trueLayerDetails: {},
};

const eurtrade = (state = initialState, action) => {
  switch (action.type) {
    case GET_PENDING_EUR_TRANSACTIONS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_PENDING_EUR_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        eurDeposits: action.payload.data,
        loading: false,
      };
    case GET_PENDING_EUR_TRANSACTIONS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case CREATE_PENDING_EUR_TRANSACTIONS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case CREATE_PENDING_EUR_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_PENDING_EUR_TRANSACTIONS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case DELETE_PENDING_EUR_TRANSACTIONS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_PENDING_EUR_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_PENDING_EUR_TRANSACTIONS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case CREATE_TRUELAYER_PAYMENT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case CREATE_TRUELAYER_PAYMENT_SUCCESS:
      return {
        ...state,
        trueLayer: action.payload.data,
        loading: false,
      };
    case CREATE_TRUELAYER_PAYMENT_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        trueLayerDetails: action.payload.data,
        loading: false,
      };
    case GET_TRUELAYER_REQUESTED_PAYMENT_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    default:
      return state;
  }
};

export default eurtrade;
